import { FC, SVGProps } from 'react'

export const ArrowRight: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M13.2379 5.4794C13.5254 5.18123 14.0002 5.1726 14.2984 5.46012L20.5206 11.4601C20.6672 11.6015 20.75 11.7964 20.75 12C20.75 12.2036 20.6672 12.3985 20.5206 12.5399L14.2984 18.5399C14.0002 18.8274 13.5254 18.8188 13.2379 18.5206C12.9504 18.2224 12.959 17.7476 13.2572 17.4601L18.1417 12.75L4 12.75C3.58579 12.75 3.25 12.4142 3.25 12C3.25 11.5858 3.58579 11.25 4 11.25L18.1417 11.25L13.2572 6.53988C12.959 6.25236 12.9504 5.77757 13.2379 5.4794Z"
			fill="currentColor"
		/>
	</svg>
)
